export function GHLCalendar() {
  const calendarId = import.meta.env.VITE_GHL_CALENDAR_ID
  if (!calendarId) {
    return (
      <div className="w-full aspect-[4/3] rounded-lg flex items-center justify-center" style={{ backgroundColor: 'var(--bg-3)' }}>
        <p className="font-body text-cream-dim">Calendar embed: set VITE_GHL_CALENDAR_ID</p>
      </div>
    )
  }
  return (
    <div className="ghl-calendar-wrapper w-full rounded-lg overflow-hidden" style={{ backgroundColor: 'var(--bg-3)', minHeight: 920 }}>
      <iframe
        src={`https://api.leadconnectorhq.com/widget/booking/${calendarId}`}
        style={{ width: '100%', minHeight: 920, height: 920, border: 'none' }}
        scrolling="yes"
        id="msgsndr-calendar"
        title="Book a discovery call"
      />
    </div>
  )
}
